import { CheckIn, CheckinIcon, CheckinOutline } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Checkin];

const config: ContentConfigProps = {
  routes: {
    create: routes.CheckinEditor,
    manageDetails: routes.AdminCheckInDetails,
    details: routes.CheckInDetails,
  },
  label: { title, createDescription },
  icons: {
    Type: CheckIn,
    Create: CheckinOutline,
    Icon: CheckinIcon,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
